

export enum EMapLayerType {
    Road = "Road",
    Satellite = "Satellite",
    None = "None"
}
interface Color {
    red: number;
    green: number;
    blue: number;
    alpha?: number | undefined;
}
export interface IMapLayer {
    id?: string,
    name?: EMapLayerType,
    imgUrl?: string,
    urlMap?: string
}
export interface IObjMap {
    skyBox?: boolean,
    backgroundColor?: Color,
    frontFaceAlpha?: number,
    globeBaseColor?: Color,
    translucencyEnabled?: boolean,
    undergroundColor?: Color,
    backFaceAlpha?: number,
    globeMaterial?: any,
    checkTerrain?: boolean,
    checkDepth?: boolean,
    valueTransparentGlobe?: number
}


export interface IObjInputMap {
    mapLayer?: IMapLayer

    optionGloble?: IObjMap

    optionDayLight?: IObjInputDaylight
}

export interface IObjInputDaylight {
    valueTime: string,
    checkBox: boolean,
    valueTimeSlider: number
    isNoneMapDaylight: boolean
    defautLight: Color
}
export interface IInputSetMap {
    transparentGlobe?: number,
    nameMap?: string,
    terrain?: boolean,
    depthTerrain?: boolean,
    shadow?: boolean
}
